<template>
    <typo
        name="body-12-medium"
        :class="`territories ${mode}`"
        :title="!isNational ? filteredTerritoryCodes.join(',') : ''"
    >
        {{ dico[territoryRange] }}
    </typo>
</template>

<script>
import { filter } from "lodash";

export default {
    props: ["territoryRange", "territoryCodes", "mode"],
    computed: {
        isNational() {
            return this.territoryRange === "national";
        },
        filteredTerritoryCodes() {
            return filter(this.territoryCodes, item => item.code != "met" && item.code != "all");
        },
        dico() {
            return this.$privateDico.convention.teaser;
        },
    },
};
</script>

<style scoped lang="sass">

.territories
    border: 1px solid white
    padding: 2px 5px
    margin: 0 10px
    text-transform: uppercase
    margin-top: -2px

.territories.dashboard,
.territories.search-result
    border: 1px solid transparentize($color-secondary, 0.5)
    // background: $color-secondary
    color: $color-secondary
</style>
